import { createFileRoute } from "@tanstack/react-router";
import ArticleSignsPoolNeedsResurfacing from "@/pages/ArticleSignsPoolNeedsResurfacing";
import { buildHead } from "@/lib/seo";
import { FEATURED_IMAGE_SIGNS_RESURFACING } from "@/data/blogData";
import { FAQS_SIGNS_POOL_NEEDS_RESURFACING } from "@/data/signsPoolNeedsResurfacingData";

const PATH = "/blog/signs-pool-needs-resurfacing";
const CANONICAL = `https://precisionpaverspools.com${PATH}`;

const blogPosting: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline:
    "Signs Your Pool Needs Resurfacing—and Signs the Problem Goes Deeper",
  description:
    "Learn which pool symptoms may point to a worn interior finish—and which cracks, water loss, movement, or recurring problems need evaluation first.",
  datePublished: "2026-10-08",
  dateModified: "2026-10-08",
  author: {
    "@type": "Organization",
    name: "Precision Pavers & Pool Design",
  },
  publisher: {
    "@type": "Organization",
    name: "Precision Pavers & Pool Design",
    url: "https://precisionpaverspools.com/",
  },
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": CANONICAL,
  },
};

if (FEATURED_IMAGE_SIGNS_RESURFACING) {
  blogPosting.image = FEATURED_IMAGE_SIGNS_RESURFACING;
}

const jsonLd: Record<string, unknown>[] = [
  blogPosting,
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://precisionpaverspools.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: "https://precisionpaverspools.com/blog",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Signs Your Pool Needs Resurfacing",
        item: CANONICAL,
      },
    ],
  },
];

// FAQPage schema is emitted only when visible FAQs exist, so the schema
// always exactly matches the on-page FAQ content.
if (FAQS_SIGNS_POOL_NEEDS_RESURFACING.length > 0) {
  jsonLd.push({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS_SIGNS_POOL_NEEDS_RESURFACING.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  });
}

export const Route = createFileRoute("/blog/signs-pool-needs-resurfacing")({
  head: () =>
    buildHead({
      title: "7 Signs Your Pool Needs Resurfacing | South Florida",
      description:
        "Learn which pool symptoms may point to a worn interior finish—and which cracks, water loss, movement, or recurring problems need evaluation first.",
      path: PATH,
      ogType: "article",
      ogImage: FEATURED_IMAGE_SIGNS_RESURFACING,
      jsonLd,
    }),
  component: ArticleSignsPoolNeedsResurfacing,
});
